module.exports = __webpack_public_path__ + "img/1500800409.781b87eb.jpg";